export enum ViewTypes {
    Yesterday = 1,
    LastWeek,
    Last7Days,
    LastMonth,
    MonthlyReports,
    CustomDates
}
